import { api, generateCRUDInterface } from "aldoo-ra/API"

const crudAPI = api("crud")
const crud = generateCRUDInterface(crudAPI, "ProductSubscriptionGroup")

crud.Get = async (get) => {
  get = {
    ...get,
    model: "ProductSubscriptionGroup",
    sort: { name: 1 },
    match: {
      ...(get.match || {}),
      deleted: { $ne: true }
    }
  }
  return await crudAPI({ get })
}

export default crud
